import { create } from 'zustand';

interface CompanyDataState {
  hasCompanyData: boolean;
  isLoading: boolean;
  isCompanyProfileComplete: boolean;
  setHasCompanyData: (hasData: boolean) => void;
  setIsLoading: (loading: boolean) => void;
  setIsCompanyProfileComplete: (isComplete: boolean) => void;
}

const useCompanyDataState = create<CompanyDataState>(set => ({
  hasCompanyData: false,
  isLoading: true,
  isCompanyProfileComplete: false,

  setHasCompanyData: (hasData: boolean) => set({ hasCompanyData: hasData }),

  setIsLoading: (loading: boolean) => set({ isLoading: loading }),

  setIsCompanyProfileComplete: (isComplete: boolean) => set({ isCompanyProfileComplete: isComplete }),
}));

export default useCompanyDataState;
